import React from 'react'
import PropTypes from 'prop-types'
import Loading from '../sitewide/Loading'

const genStyles = (isEmail, isTops) => ({
  wrapper: {
    minHeight: `calc(100% - ${isEmail ? 251 : 150}px)`,
    position: 'absolute',
    top: 51,
    left: 0,
    backgroundColor: isTops ? '#dee1cb' : 'white',
    zIndex: 10,
  },
})

const LoadingIcon = ({ isEmail, isTops }) => (
  <Loading style={genStyles(isEmail, isTops)} />
)

LoadingIcon.propTypes = {
  isEmail: PropTypes.bool.isRequired,
  isTops: PropTypes.bool,
}

export default LoadingIcon



// WEBPACK FOOTER //
// ./src/components/Messages/LoadingIcon.js